module.exports = __webpack_public_path__ + "static/media/BD.b86cb979.png";